import React from 'react';
import { Select } from 'antd';
import 'baseComponents/ClearableSelectComponent/clearableSelectComponent.scss';
import { InputComponentWrapper } from 'baseComponents/InputComponentWrapper';

type MultiSelectDropdownProps = {
  options: any[];
  onChange?: (selectedValues: any) => void;
  onClear?: () => void;
  placeholder?: string;
  value?: any;
  showSearch?: boolean;
  onSearch?: (searchValue: string) => void;
  className?: string;
};

// Filter `option.label` match the user type `input`
const filterOption = (
  input: string,
  option?: { label: string; value: string }
) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

export const ClearableSelectComponent: React.FC<MultiSelectDropdownProps> = (
  props
) => {
  return (
    <InputComponentWrapper>
      <Select
        className={`multi-select-dropdown ${props.className}`}
        allowClear
        onClear={props.onClear}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value}
        popupClassName='multi-select-popup'
        options={props.options}
        showSearch={props.showSearch}
        onSearch={props.onSearch}
        filterOption={filterOption}
      />
    </InputComponentWrapper>
  );
};
